import { Alert, AlertTitle, Button } from "@mui/material";

function EditingLockBanner({
  lockedBy,
  lockedSince,
  onForceUnlock,
  canForceUnlock = false,
}) {
  if (!lockedBy) return null;

  let desde = "";
  try {
    if (lockedSince) {
      desde = new Date(lockedSince).toLocaleString("pt-BR");
    }
  } catch {
    desde = "";
  }

  return (
    <Alert
      severity="warning"
      role="alert"
      sx={{ mb: 2 }}
      action={
        canForceUnlock ? (
          <Button color="inherit" size="small" onClick={onForceUnlock}>
            Assumir controle
          </Button>
        ) : null
      }
    >
      <AlertTitle>Em edição por {lockedBy.nome || "outro usuário"}</AlertTitle>
      {desde && <>Desde {desde}. </>}
      Os campos estão somente-leitura para evitar sobrescrita acidental.
    </Alert>
  );
}

export default EditingLockBanner;
